import * as React from 'react';
import MuiBadge, { type BadgeProps as MuiBadgeProps } from '@mui/material/Badge';

export interface BadgeProps extends Omit<MuiBadgeProps, 'badgeContent' | 'variant'> {
  /**
   * Badge content. Pass `true` to render a dot badge with no content.
   * Pass a number or string for a standard badge.
   */
  content?: string;
}

/**
 * Badge wrapper - maps a simplified API to MUI Badge
 * - `content={true}` renders a dot badge (variant="dot", no badgeContent)
 * - Any other `content` value renders a standard badge
 */
const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ content, children, ...rest }, ref) => {
  const isDot = typeof content !== 'string';

  return (
    <MuiBadge ref={ref} badgeContent={isDot ? undefined : content} variant={isDot ? 'dot' : 'standard'} {...rest}>
      {children}
    </MuiBadge>
  );
});

Badge.displayName = 'Badge';

export default Badge;
